import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
  userFarmers: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },
  userFarms: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  }, 
  animalConditions: {
    requesting: false,
    items: [],
    error: null,
    success: false,
    filters: {},
  },  
};

export const dynamicListSlice = createSlice({
  name: 'dynamicList',
  initialState,
  reducers: {
    getUserFarmers: (state, action) => {		      
        state.userFarmers.requesting = true;
        state.userFarmers.error = null;
        state.userFarmers.items = [];
        state.userFarmers.success = false;
        state.userFarmers.filters = action.payload;
    },
    getUserFarmersSuccess: (state, action) => {
      console.log(action.payload);
      state.userFarmers.requesting = false;
      state.userFarmers.items = action.payload;
      state.userFarmers.success = true; 
    },
    getUserFarmersFail: (state, action) => {        
        state.userFarmers.requesting = false;
        state.userFarmers.error = action.payload;
    },  
    
    getUserFarms: (state, action) => {		      
      state.userFarms.requesting = true;
      state.userFarms.error = null;
      state.userFarms.items = [];
      state.userFarms.success = false;
      state.userFarms.filters = action.payload;
    },
    getUserFarmsSuccess: (state, action) => {
      state.userFarms.requesting = false;
      state.userFarms.items = action.payload;
      state.userFarms.success = true; 
    },
    getUserFarmsFail: (state, action) => {        
        state.userFarms.requesting = false;
        state.userFarms.error = action.payload;
    },

    getAnimalConditions: (state, action) => {		      
      state.animalConditions.requesting = true;
      state.animalConditions.error = null;
      state.animalConditions.items = [];
      state.animalConditions.success = false;
      state.animalConditions.filters = action.payload;
    },
    getAnimalConditionsSuccess: (state, action) => {
      state.animalConditions.requesting = false;
      state.animalConditions.items = action.payload;
      state.animalConditions.success = true; 
    },
    getAnimalConditionsFail: (state, action) => {        
      state.animalConditions.requesting = false;
      state.animalConditions.error = action.payload;
    },
    
  },
})

export const { 
  getUserFarmers, getUserFarmersSuccess, getUserFarmersFail,
  getUserFarms, getUserFarmsSuccess, getUserFarmsFail,
  getAnimalConditions, getAnimalConditionsSuccess, getAnimalConditionsFail
} = dynamicListSlice.actions

export default dynamicListSlice.reducer